import {Box, Divider, Stack, Typography} from "@mui/material";
import {appStyles} from "../../AppStyles.ts";
import {appSession} from "../../TR3AD.ts";
import {useEffect, useState} from "react";
import {SessionNetwork} from "../../sdo/SessionNetwork.ts";
import SessionNetworkCard from "../../cards/SessionNetworkCard.tsx";
import {Navigate, useLocation} from "react-router";

export type NetworkViewState = {
    autoConnect: boolean | undefined;
    networkUID: string | undefined;
    redirectURL: string | undefined
}

function UXNetworkSelect() {
    const location = useLocation();
    const viewState = location.state as NetworkViewState | null;

    const [networks, setNetworks] = useState<SessionNetwork[]>([]);
    // const [filterText, setFilterText] = useState("");

    useEffect(() => {
        reload();
    }, []);

    function reload() {
        console.log("UXNetworkSelect::reload");
        appSession.getNetworks((success, networks, message) => {
            if (success) {
                console.info("Loading networks...")
                setNetworks(networks);

                if (viewState?.autoConnect)
                {
                    //TODO: Find network key

                    if (viewState.redirectURL)
                    {
                        //TODO: Navigate to redirect URL
                    }
                }
            } else {
                console.log(message);
            }
        });
    }

    const filteredNetworks = networks; // For now, no filter

    return (
        <Stack direction="column" width="100%" alignItems="center" >
            {
                appSession.activeSession() === false ? (
                <Navigate to="/" />
            ) : (
            <Stack sx={appStyles.defaultPanelContainer} spacing={2} width="100%" height="100%" alignItems="center">
                <Box sx={appStyles.networkCardsWrapper}  width="98%" height="100%">
                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                        <Typography sx={appStyles.mainIntelTitle}>
                            TR3AD Networks
                        </Typography>
                    </Stack>
                    {/* Card grid/list */}
                    <Box sx={{ overflowY: "auto", flexGrow: 1, p: 1 }}>
                        <Box
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 2,
                                alignItems: "flex-start",
                                justifyContent: "center", // <-- makes rows of cards centered, not edge-to-edge
                                width: "100%"
                            }}
                        >
                            {
                                networks == null || networks.length === 0 ?
                                    <Typography variant="body2" color="text.secondary">Loading networks...</Typography>
                                    :
                                    filteredNetworks.map(nextNetwork => (
                                        <SessionNetworkCard key={"network_" + nextNetwork.key} entry={nextNetwork} />
                                    ))
                            }
                        </Box>
                    </Box>
                    {/* Divider and showing label */}
                    <Divider sx={{ my: 2 }} />
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        align="center"
                        sx={{ width: "100%" }}
                    >
                        Showing {filteredNetworks.length} of {networks.length} networks
                    </Typography>
                </Box>
            </Stack>
            )}
        </Stack>
    );
}

export default UXNetworkSelect;


